<div class="loading-overlay" [hidden]="(isLoading | async) === false">
	<img class="spinner" src="./assets/spinner2.gif" />
</div>

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'masterdata.palletising.groupings' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput [placeholder]="'masterdata.palletising.search' | translate" [(ngModel)]="groupingsFilter" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<app-generictable [hidden]="(count$ | async) <= 0" [tableSource]="tableSource" [tableColumns]="registerTableColumns" [filterWord]="groupingsFilter" [rowActions]="rowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
